import $store from '@/store/index'

class QueueHelper {
  constructor () {
    $store.dispatch('queue/fetchEntries')
    this.changeInterval()
  }

  changeInterval (newInterval = 60000) {
    if (this.interval) {
      clearInterval(this.interval)
    }

    this.interval = setInterval(() => {
      $store.dispatch('queue/fetchEntries')
    }, newInterval)
  }

  destroy () {
    clearInterval(this.interval)
  }
}

const QueueHelperInstance = new QueueHelper()

export default QueueHelperInstance
